import React from 'react';
import Header from "../../components/header";
import Footer from "../../components/footer";
import { connect } from "react-redux";
import { searchByAll, getByPractice, getFacilityAddress } from "../../services/patient/action";
import CustomSearch from '../../components/customsearch'
import $ from 'jquery';
import { NavLink } from "react-router-dom";
import { footer } from "../../components/footerSize";
import Pagination from '../common/pagination';



class PatientRequest extends React.Component {

   constructor(props) {
      super(props)
      this.state = {
         facilityList: [],
         practiceName: "",
         doctorName: "",
         location: "",
         practiceList: [],
         doctorList: [],
         practiceId: "",
         doctorId: "",
         locationList: [],
         locationId: 0,
         selectFac: "",
         selectedFacilityId: "",
         isChecked: false,
         searched: false,
         locationValid: false,
         doctorandPracticeValid: false,
         headerName: "",
         pageOfItems: []

      }
   }

   onChangePage = (pageOfItems) => {
      // update state with new page of items
      this.setState({ pageOfItems: pageOfItems });
   }


   // filterStatusBased = (List) => {
   //    const facilityList = List.filter((facility) => {
   //       return facility.registrationStatus === "approved"
   //    })

   //    this.setState({
   //       facilityList
   //    })
   // }

   componentDidMount() {
      // onDocumentReady function bind
      $(document).ready(function () {
         footer("#content");
      });

      // onResize bind of the function
      $(window).resize(function () {
         footer("#content");
      });

      let access_token = this.props.loginDetails;

      this.props.getByPractice(access_token);
   }





   filterFinal = () => {
      let { practiceId, doctorId, locationId } = this.state;
      let token = this.props.loginDetails;

      let headerName;
      if (practiceId !== "" && doctorId !== "") {
         headerName = "Practice / Doctor"
      } else if (practiceId !== "" && doctorId === "") {
         headerName = "Practice"
      } else if (practiceId === "" && doctorId !== "") {
         headerName = "Doctor"
      }
      this.setState({
         headerName
      })
      let payload = {
         "facilityName": practiceId,
         "doctorsName": doctorId,
         "locationId": locationId
      }

      var formBody = [];
      for (var property in payload) {
         var encodedKey = encodeURIComponent(property);
         var encodedValue = encodeURIComponent(payload[property]);
         formBody.push(encodedKey + "=" + encodedValue);
      }
      formBody = formBody.join("&");

      this.props.searchByAll(token, formBody)

   }

   componentWillReceiveProps = nextProps => {

      // if (nextProps.facilityListStatus) {
      //    let List = nextProps.facilityListDetails.facilityListObj;
      //    this.filterStatusBased(List)
      // }
      if (nextProps.getByPracticeStatus) {
         let practiceList = nextProps.getByPracticeDetails.facilityListSearch
         this.setState({
            practiceList
         })
      }
      if (nextProps.getByDoctorStatus) {
         let doctorList = nextProps.getByDoctorDetails.practionerObj
         this.setState({
            doctorList
         })
      }
      if (nextProps.getByLocationStatus) {
         let locationList = nextProps.getByLocationDetails.stateListObj;
         this.setState({
            locationList
         })
      }
      if (nextProps.searchByAllStatus) {
         let facilityList = nextProps.searchByAllDetails.finalSearchDetails;

         this.setState({
            searched: true,
            facilityList
         })
      } else {
         this.setState({
            searched: false,
            facilityList: []
         })
      }

      if (nextProps.getFacilityAddressStatus) {
         this.props.history.push("/PatientRecord")

      }


   }



   searchInputs = (e) => {
      this.setState({
         [e.target.name]: e.target.value
      }, () => {
         if (this.state.practiceId !== "" || this.state.doctorId !== "") {
            this.setState({
               doctorandPracticeValid: true
            })
         } else {
            this.setState({
               doctorandPracticeValid: false
            })
         }
      }
      )


   }



   locationId = (id) => {
      this.setState({
         locationId: id,

      }, () => {
         if (this.state.locationId !== "0") {
            this.setState({
               locationValid: true
            })
         } else {
            this.setState({
               locationValid: false
            })
         }
      }
      )


   }
   selectFacilty = (e, facility) => {

      this.setState({
         selectedFacilityId: e.target.value,
         isChecked: true,
      })
   }



   naveToRecordPage = () => {
      const { selectedFacilityId, doctorId } = this.state;
      let token = this.props.loginDetails;

      let payload = {
         selectedFacilityId,
         doctorId
      }


      this.props.getFacilityAddress(token, payload)


   }

   render() {

      const {
         isChecked,
         searched,
         locationValid,
         doctorandPracticeValid,
         headerName,
      } = this.state;
      console.log("vgffgyfyfyfyf",this.state.locationId, typeof(this.state.locationId) )

      return (
         <>
            <Header status={"afterLogin"} routes={[{ "name": "Home", "route": "/PatientHome", }, { "name": "Select a Practice/Doctor", "route": "/PatientRequest", }]} />
            <div className="content">
               <div className="contentSection" id="content">
                  <div className="container-fluid">

                     <div className="bodyContent">
                        <h3 className="title-text">Step 1 : Select a Practice/Doctor</h3>
                        <div className="row">

                           <div className="col-md-3">
                              <div className="form-group">
                                 <label class="practises" htmlFor="firstname">State</label><sup>*</sup>
                                 {/*06June2019 without kurra,added below condtion*/}
                                 {/* <CustomSearch placeholder="Enter State Name" values={this.state.locationList} practiceId={this.locationId} /> */}
                                    <select onChange={(e) => this.locationId(e.target.value)} className="form-control" id="sel1" name="state" >
                                          <option value={"0"} >State </option>
                                          {this.state.locationList.length > 0 ?
                                                this.state.locationList.map((state, id) => {
                                                      return (
                                                            <option key={id} value={state.id}>{state.name} </option>
                                                      )
                                                }) : ""

                                          }
                                    </select>
                              </div>
                           </div>
                           <div className="col-md-3">
                              <div className="form-group aftericon posrelative">
                                 <label class="practises" htmlFor="firstname">Practice Name</label>
                                 <input type="text" placeholder="Enter Practice Name" name="practiceId" value={this.state.practiceId} onChange={this.searchInputs} />
                              </div>
                           </div>

                           <div className="col-md-4">
                              <div className="form-group">
                                 <label class="practises" htmlFor="firstname">Enter First Few Letters of Doctor’s First or Last Name</label>
                                 <input type="text" placeholder="Enter First Few Letters of Doctor’s First or Last Name" name="doctorId" value={this.state.doctorId} onChange={this.searchInputs} />
                              </div>
                           </div>

                           <div className="col-md-2 ">
                              <div className="form-group">
                                 <button disabled={!locationValid || !doctorandPracticeValid} onClick={this.filterFinal} type="button" className="btnDefault marginTop20" title={(!locationValid || !doctorandPracticeValid) ? "Please search with state and doctor or practice" : ""} style={{backgroundColor:"#FF8C00"}}>Search</button>
                              </div>
                           </div>

                        </div>
                        <div className="row">
                           <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              {searched ?
                                 <div className="table-responsive">
                                    <table className="table commonTable">
                                       <thead>
                                          <tr>
                                             <th>Select</th>
                                             <th>{headerName}</th>
                                             <th>Address</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          {this.state.pageOfItems.length > 0 ?
                                             this.state.pageOfItems.map((facility, id) => {
                                                return (
                                                   <tr key={id}>
                                                      <td >
                                                         <input onClick={(e) => this.selectFacilty(e, facility)} value={facility.facilityId} className="inp-cbx" id={id} type="radio" name="selpra" style={{ display: "none" }} />
                                                         <label className="cbx" htmlFor={id}><span>
                                                            <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                               <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                                            </svg></span></label></td>
                                                      <td><span>{facility.facilityName}</span>{facility.facilityName && facility.practitionersFirstName ? " /" : ""}  <span>{facility.practitionersFirstName} {facility.practitionersLastName} </span></td>
                                                      <td>{facility.facilityAddress}, {facility.facilityCity}, {facility.state}</td>
                                                   </tr>
                                                )
                                             }) : <tr style={{ background: "transparent" }}><td colspan="6"><img src="images/no-record-found.png" alt="" width="180px" style={{ opacity: "0.6" }} /></td></tr>

                                          }

                                       </tbody>
                                    </table>
                                 </div>
                                 : 
                                 <ul className="list-style-none">
                                    <li> To search for a doctor or medical practice:</li>
                                    <li>1. Fill out the state in which the doctor or medical practice is located.</li>
                                    <li>2. Fill in either the Practice Name box or the Doctor's last name box but not both.</li>
                                    <li>The easiest way to search is simply to enter the first 3 letters of the doctor's last name.</li>
                                    <li>Once you choose one doctor in a practice you will receive all records for that whole practice,</li>
                                 <li>unless you specify otherwise in the Next Step.</li>
                                 </ul>
                              
                                 // <p>2. Fill in either the Practice Name box of the Doctor's last name box but not both.</p> 
                                 // <p>The easiest way to search is simply to enter the first 3 letters of the doctor's last name.</p>
                                 // <p>Once you choose one doctor in a practice you will receive all records for that whole practice,</p>
                                 // <p>unless you specify otherwise in the Next Step.</p>
  
                              }
                           </div>

                           {searched &&
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">
                                 <Pagination items={this.state.facilityList} onChangePage={this.onChangePage} />
                              </div>
                           }


                           <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 reqs-btn ">
                              <NavLink to="/PatientNewRequest"> <button type="button" className="btnDefault">I can’t find my Practice
                        </button></NavLink>
                              {/* <NavLink to="/PatientRecord"> <button type="button" className="btnDefault">Next Step</button></NavLink>  */}
                              {/* 06June2019 without kurra,added below condtion  */}
                              <button type="button" disabled={!isChecked} onClick={this.naveToRecordPage} title={!isChecked ? "Please choose a doctor or practice" : ""} className="btnDefault pat-req" >Next Step</button>


                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <Footer />
         </>
      )
   }
}



const mapStateToProps = state => ({

   loginDetails: state.commonReducer.loginDetails,
   profileDetails: state.commonReducer.profileDetails,
   facilityListDetails: state.patientReducer.facilityListDetails,
   facilityListStatus: state.patientReducer.facilityListStatus,

   getByPracticeStatus: state.patientReducer.getByPracticeStatus,
   getByDoctorStatus: state.patientReducer.getByDoctorStatus,
   getByLocationStatus: state.patientReducer.getByLocationStatus,
   searchByAllStatus: state.patientReducer.searchByAllStatus,

   getByPracticeDetails: state.patientReducer.getByPracticeDetails,
   getByDoctorDetails: state.patientReducer.getByDoctorDetails,
   getByLocationDetails: state.patientReducer.getByLocationDetails,
   searchByAllDetails: state.patientReducer.searchByAllDetails,

   getFacilityAddressStatus: state.patientReducer.getFacilityAddressStatus,

   message: state.employeeReducer.message
});

const mapDispatchToProps = dispatch => ({
   getByPractice: token => dispatch(getByPractice(token)),
   searchByAll: (token, formBody) => dispatch(searchByAll(token, formBody)),
   getFacilityAddress: (token, payload, ) => dispatch(getFacilityAddress(token, payload))
});

export default connect(
   mapStateToProps,
   mapDispatchToProps
)(PatientRequest);


